module.exports = __webpack_public_path__ + "static/media/30x30.7d1cb2e6.png";